import { useState } from "react";
import { Badge, Button, Card, Col, Dropdown, Form, Modal, Row, Stack } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import Api from "../../../api/Api";
import { downloadExcelAuditResults } from "../../reuse/downloadExcelAuditResults";


const ModalDeleteWarning = ({data}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deleteAudit = async(audit_id, password) => {
        try {
            const response = await Api({
                method:"delete",
                url:`/audits/@${audit_id}`,
                headers:{password:password}
            })
            alert("Аудит удалён из системы");
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при удалении аудита. \n ${error}`);
        }
    }

    const handleDelete = async() => {
        const password=document.getElementById("password_data_delete").value;
        if (password!=="" && password!==null){
            await deleteAudit(data.id, password)
        }else{
            alert("Введите пароль!")
        }
    }

    return(
        <>
            <Dropdown.Item onClick={handleShow}>Удалить</Dropdown.Item>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title className="text_font">Внимание</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Text className="text_font">Вы уверены, что хотите удалить аудит "{data.name}" из системы? После удаления, его нельзя будет восстановить!</Form.Text>
                    <Form.Control 
                    id="password_data_delete"
                    placeholder="Для подтверждения введите пароль пользователя..." 
                    required 
                    type="password"/>
                    <Row className="mt-2">
                        <Col>
                            <Button 
                            variant="light" 
                            className="free-btn"
                            onClick={handleClose}>Отмена</Button> 
                        </Col>
                        <Col>
                            <Button 
                                variant="danger" 
                                className="free-btn" 
                                onClick={()=>handleDelete()}>Да, удалить</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}


const ArchiveAuditCard = ({audit}) => {
    const audit_types={"common":"Обычный","self-esteem":"Самоаудит"}

    const handleLink = () => {
        if(audit.results_access){
            window.location.href=`/audit_result_page/${audit.id}`
        }else{
            alert("У вас нет доступа к результатам аудита!")
        }
    }

    return(
        <>
        <Card className="mt-2 mb-1 audit_card_block">
            <Card.Body>
                <div>
                    <Stack direction="horizontal">
                        <div className="text_font">{new Date(audit.start_datetime).toLocaleDateString()} - {new Date(audit.end_datetime).toLocaleDateString()}</div>
                        <div className="ms-auto">
                            <Dropdown align="end">
                            <Dropdown.Toggle variant="light border" id="dropdown-basic" size="md">
                                <BsThreeDots />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {/* {audit.results_access && <Dropdown.Item href={`/audit_result_page/${audit.id}`}>Посмотреть результаты</Dropdown.Item>} */}
                                {audit.results_access && <Dropdown.Item href={`/audit_result_page/${audit.id}`}>Посмотреть результаты</Dropdown.Item>}
                                <Dropdown.Item onClick={()=>downloadExcelAuditResults(audit.id)}>Скачать Excel</Dropdown.Item>
                                <ModalDeleteWarning data={{id:audit.id, name:audit.name}}/>
                            </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Stack>
                </div>
                <div className="d-flex">
                    <div className="custom_badge_secondary">{audit_types[audit.audit_type]}</div>
                </div>
                <div onClick={()=>{handleLink()}}>
                    <div className="text_font">Завод: {audit.facility}</div>
                    <div className="text_font audit_card_block_text">{audit.name}</div>
                </div>
            </Card.Body>
        </Card>
        </>
    )
}

export default ArchiveAuditCard;